import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { Router, RouterModule } from '@angular/router';
import { NotificationsDetail } from 'src/app/core/notifications/interfaces/notifications.interface';
import { NotificationsService } from 'src/app/core/notifications/services/notifications.service';
import { LayoutService, TitleToolbar } from 'src/app/core/services/layout.service';
import { RevisionService } from 'src/app/core/services/revision.service';
import { scaleFadeIn400ms } from 'src/app/shared/animations/scale-fade-in.animation';
import { MatDialog } from '@angular/material/dialog';
import { VersionAlertComponent } from 'src/app/shared/components/version-alert/version-alert.component';
import { ConfigurationsService } from 'src/app/shared/services/configurations.service';
import { environment as env } from 'src/environments/environment';
import { IconComponent } from 'src/app/shared/components/icon/icon.component';
import { ActivityComponent } from './components/activity-task/activity.component';
import { VersionNewsComponent } from './components/version-news/version-news.component';
import { NotificationsModule } from 'src/app/core/notifications/notifications.module';
import { MatBadgeModule } from '@angular/material/badge';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { ToolbarUserComponent } from './components/toolbar-user/toolbar-user.component';
import { ClockComponent } from './components/clock/clock.component';
import { IntervalMarksComponent } from "../interval-marks/interval-marks.component";
import { IntervalService } from '../interval-marks/service/interval-service.service';
import { localDB } from 'src/app/shared/helpers/localStorage';
import * as moment from 'moment';
import { MarkingService } from 'src/app/shared/components/marking/service/marking.service';
import { combineLatest, map } from 'rxjs';
import { AccessService } from 'src/app/core/services/access.service';

@Component({
  selector: 'mg-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  standalone: true,
  imports: [
    ClockComponent,
    ActivityComponent,
    ToolbarUserComponent,
    VersionNewsComponent,
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    MatMenuModule,
    MatButtonModule,
    RouterModule,
    MatSidenavModule,
    IconComponent,
    MatProgressBarModule,
    MatBadgeModule,
    NotificationsModule,
    IntervalMarksComponent
  ],
  animations: [scaleFadeIn400ms]
})
export class ToolbarComponent implements OnInit {
  @Input() isDesktop: boolean | null;
  @Input() sidenav: MatSidenav;
  @ViewChild('menuTriggerNotifications') menuTriggerNotifications: MatMenuTrigger;

  public readNotifications = false;
  public title: TitleToolbar | null;
  public notificationsData: NotificationsDetail[] = [];
  public counterNotifications = 0;
  public messages = [];
  public isNewsButtonDisabled = false;

  isScreenSMD$ = this._layoutService.isScreenSMD$;
  isDesktop$ = this._layoutService.isScreenXL$;
  isMainDashboard$ = this._layoutService.currentRouteObservable;
  isTaskPage$ = this._layoutService.taskRouteObservable;

  isHiddenActivity$ = combineLatest([
    this.isMainDashboard$,
    this.isTaskPage$
  ]).pipe(map(([isDashboard, isTareo]) => isDashboard || isTareo));

  env = env;

  public marksData: any;
  public myHoursData: any;
  public extempData: any;

  constructor(
    private readonly _router: Router,
    private readonly _revisionService: RevisionService,
    private readonly _layoutService: LayoutService,
    private readonly _configurationsService: ConfigurationsService,
    private readonly _notificationsService: NotificationsService,
    private readonly dialog: MatDialog,
    private readonly _intervalService: IntervalService,
    private readonly _markingService: MarkingService,
    public _accessService: AccessService
  ) { }

  ngOnInit(): void {
    this.ObtainMarksInterval();
    this._revisionService.fetchDataFromRevision();

    this._layoutService.titleToolbar$.subscribe((titleConfig) => {
      this.title = titleConfig;
    });

    this._notificationsService.countNotifications$.subscribe(x => {
      this.badgeCounterNotifications(x);
    });

    this._intervalService.event$.subscribe(isReload => {
      if (isReload) this.ObtainMarksInterval(true);
    });
  }

  onUpdateAttendance(value: boolean) {
    if (value) this.ObtainMarksInterval();
  }

  badgeCounterNotifications(counter: number) {
    setTimeout(() => {
      this.counterNotifications = counter;
    }, 0);
  }

  goNotifications() {
    this._notificationsService.getNotifications().subscribe({
      next: (resp) => {
        if (resp?.isSuccess) {
          const ids: number[] = [];
          this.notificationsData = resp.data;

          for (const n of this.notificationsData) {
            if (!n.bIsRead) ids.push(n.nId_Notificacion);
          }

          if (ids.length) {
            this._notificationsService.countNotifications.next(0);
            this._notificationsService
              .updateStateNotificationsCondition(ids)
              .subscribe(() => { });
          }
        }
      }
    });

    this.readNotifications = true;
    this._router.navigate(["notificaciones"]);
    setTimeout(() => {
      this.readNotifications = false;
    }, 500);
  }

  goHelp() {
    window.open('https://manual.appsmart.pe/', '_blank', 'noopener');
  }

  openNewsModal() {
    if (this.isNewsButtonDisabled) return;

    this.isNewsButtonDisabled = true;
    setTimeout(() => {
      this.isNewsButtonDisabled = false;
    }, 5000);

    this._configurationsService.getVersion(env.version).subscribe((versionResponse: any) => {
      this.dialog.open(VersionAlertComponent, {
        data: versionResponse.data,
        disableClose: true
      });
    });
  }

  ObtainMarksInterval(isObservable?: boolean) {
    const nid_colaborador = Number(localDB.getItem('idColaborador'));
    let dfecha_jornada = moment().format("YYYY-MM-DD");

    if (moment().hours() <= 6) {
      dfecha_jornada = moment().subtract(1, 'days').format("YYYY-MM-DD");
    }

    this._intervalService.getUserSchedule(dfecha_jornada).subscribe({
      next: (resp) => {
        this.myHoursData = resp;
      }
    });

    this._intervalService.getMarksUser(nid_colaborador, dfecha_jornada, true).subscribe({
      next: (resp) => {
        this.marksData = resp;
        if (isObservable) this._intervalService.ReloadMarks(true);
      }
    });

    this._markingService.getRedButton().subscribe({
      next: (resp) => {
        this.extempData = resp;
      }
    });
  }
}
